import {
  Button,
  Card,
  Inline,
  Link,
  Stack,
  Typography,
  Viewport,
} from '@omnipresentgroup/design-system';
import type { ReactElement } from 'react';

import { useManagerUser } from '../../../../hooks';
import { WrappedMixpanel } from '../../../../mixpanelWrapper';

const ASSESSMENT_LINK = 'https://omnipresentgroup.typeform.com/to/t24Kn2FT';

export const CARD_TITLE = 'Risk of misclassification';

const ResponsiveLayout = ({
  children,
}: {
  children: ReactElement | ReactElement[];
}) => {
  return (
    <>
      <Viewport devices={['phone']}>
        <Stack justify="center" gap="16">
          {children}
        </Stack>
      </Viewport>
      <Viewport devices={['highRes', 'desktop', 'laptop', 'tablet']}>
        <Inline justify="space-between" align="center">
          {children}
        </Inline>
      </Viewport>
    </>
  );
};

export const MisclassificationRiskCard = () => {
  const { userId } = useManagerUser();

  return (
    <Card>
      <Stack p="16" bg="page" gap="8">
        <ResponsiveLayout>
          <Typography as="h4" size="14" weight="medium" hideParagraphSpacing>
            {CARD_TITLE}
          </Typography>
          <Button
            variant="secondary"
            icon="ExternalLink"
            size="small"
            as={Link}
            to={ASSESSMENT_LINK}
            target="_blank"
            onClick={() => {
              WrappedMixpanel.track('Take Assessment Button Clicked', {
                userId: userId,
              });
            }}
          >
            Take our assessment
          </Button>
        </ResponsiveLayout>
        <Typography as="p" size="14" hideParagraphSpacing>
          The distinction between an independent contractor and an employee
          involves several factors such as control over work, invoicing
          practices, tax responsibilities, and benefits eligibility. Incorrect
          classification may result in lawsuits, the obligation to pay back
          taxes, and the imposition of fines and penalties.
        </Typography>
      </Stack>
    </Card>
  );
};
